import {
  getVendorOrdersStart,
  getVendorOrdersSuccess,
  getVendorOrdersFailure,
  getPaymentDetailsStart,
  getPaymentDetailsSuccess,
  getPaymentDetailsFailure,
  updateDeliveryStatusStart,
  updateDeliveryStatusSuccess,
  updateDeliveryStatusFailure,
  getAllOrdersStart,
  getAllOrdersSuccess,
  getAllOrdersFailure,
  getReturnOrdersStart,
  getReturnOrdersSuccess,
  getReturnOrdersFailure,
  updateReturnStatusStart,
  updateReturnStatusSuccess,
  updateReturnStatusFailure,
  resetVendorState,
  getPaymentDetailsByAdminStart,
  getPaymentDetailsByAdminSuccess,
  getPaymentDetailsByAdminFailure,
} from "./orderSlice";
import { 
  getAllVendorOrders, 
  getPaymentDetails, 
  updateDeliveryStatus,
  getAllOrders,
  getAllReturnOrders,
  updateReturnStatus,
  getPaymentDetailsByAdmin
} from "services/orderService";

export const fetchVendorOrders = () => async (dispatch) => {
  try {
    dispatch(getVendorOrdersStart());
    const response = await getAllVendorOrders();
    dispatch(getVendorOrdersSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getVendorOrdersFailure(error.message));
    throw error;
  }
};

export const fetchPaymentDetails = () => async (dispatch) => {
  try {
    dispatch(getPaymentDetailsStart());
    const response = await getPaymentDetails();
    dispatch(getPaymentDetailsSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getPaymentDetailsFailure(error.message));
    throw error;
  }
};

//fetch payments details by admin
export const fetchPaymentDetailsByAdmin = () => async (dispatch) => {
  try {
    dispatch(getPaymentDetailsByAdminStart());
    const response = await getPaymentDetailsByAdmin();
    dispatch(getPaymentDetailsByAdminSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getPaymentDetailsByAdminFailure(error.message));
    throw error;
  }
};

export const updateOrderDeliveryStatus = (orderId, deliveryStatus) => async (dispatch) => {
  try {
    dispatch(updateDeliveryStatusStart());
    const response = await updateDeliveryStatus(orderId, deliveryStatus);
    dispatch(updateDeliveryStatusSuccess({ orderId, deliveryStatus }));
    return response;
  } catch (error) {
    dispatch(updateDeliveryStatusFailure(error.message));
    throw error;
  }
};

export const fetchAllOrders = () => async (dispatch) => {
  try {
    dispatch(getAllOrdersStart());
    const response = await getAllOrders();
    dispatch(getAllOrdersSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getAllOrdersFailure(error.message));
    throw error;
  }
};

//  Get return orders action
export const fetchReturnOrders = () => async (dispatch) => {
  try {
    dispatch(getReturnOrdersStart());
    const response = await getAllReturnOrders();
    dispatch(getReturnOrdersSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getReturnOrdersFailure(error.message));
    throw error;
  }
};

//  Update return status action
export const updateOrderReturnStatus = (orderId, action) => async (dispatch) => {
  try {
    dispatch(updateReturnStatusStart());
    const response = await updateReturnStatus(orderId, action);
    dispatch(updateReturnStatusSuccess({ orderId, action }));
    return response;
  } catch (error) {
    dispatch(updateReturnStatusFailure(error.message));
    throw error;
  }
};

export const resetOrderState = () => (dispatch) => {
  dispatch(resetVendorState());
};